import React from 'react';
import PropTypes from 'prop-types';
import classes from './edit_activity_modal.module.scss';
import Modal from '../../../../_common/Modal/Modal';
import Activity from '../../SinglePossiblePerson/HeaderTabs/Activity';

function EditActivityModal({ open, close }) {
  return (
    <Modal open={open} className={classes.modal_wrapper} onClose={close}>
      <Activity modal className={classes.activity_modal_wrapper} />
    </Modal>
  );
}

EditActivityModal.protoTypes = {
  open: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
};
export default EditActivityModal;
